import React, { useState, useEffect } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
// import TabsData from '../modules/TabsData';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import TitleTextButton from '../modules/TitleTextButton';
import Header_3 from '../headers/Header_3';
import SEO from '../components/Seo';
import HauswartungTabData from '../components/HauswartungTabData';
import Header_2 from '../headers/Header_2';

export const WohnenHauswartung = () => {



    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [telephoneData, setTelephoneData] = useState(null);
    const [modules, setModules] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);

    const [metaData, setMetaData] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/hauswartung?populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Video]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Button]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Video]=true&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[Modul][on][modules.projekte-portfolio][populate][neubauprojekte_posts][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.news][populate][Kurztitel_Titel_Text_Button][populate]=*&populate[Modul][on][modules.news][populate][aktuelles][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.news][populate][aktuelles][populate][Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.news][populate][aktuelles][populate][Bannerbereich][on][header.header-1-titel-text][populate][Button][populate]=*&populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*&populate[Modul][on][modules.notfallnummern][populate][Modul][populate][Modul][populate][Icon][populate]=true&populate[Metadaten]=*");


            // populate[Modul][on][modules.notfallnummern][populate][Modul][populate][Modul][populate][Icon][populate]=true
            // populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*

            const data = await response.json();
            console.log(data?.data?.Modul);

            if (data.data) {
                setPageData(data.data);
                setMetaData(data.data?.Metadaten);
                setModules(data?.data?.Modul)
                setHeaderModules(data?.data?.Bannerbereich);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    const getTelephoneData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/hauswartlistes?populate=*&pagination[page]=1&pagination[pageSize]=1000");


            // populate[Modul][on][modules.notfallnummern][populate][Modul][populate][Modul][populate][Icon][populate]=true
            // populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*

            const data = await response.json();

            if (data.data) {
                console.log('telephone', data.data)
                setTelephoneData(data?.data);
                setFilteredTelephoneData(data?.data);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
        getTelephoneData();
    }, [])


    const [searchTerm, setSearchTerm] = useState('');
    // const [filteredTelephoneData, setFilteredTelephoneData] = useState([]);

    const [isFiltered, setIsFiltered] = useState(false);

    const [filters, setFilters] = useState({
        hauswarte: "",
        strasse: "",
        hausnummer: "",
        ort: "",
    });

    const [filteredTelephoneData, setFilteredTelephoneData] = useState([]);

    const [suggestions, setSuggestions] = useState({
        hauswarte: [],
        strasse: [],
        hausnummer: [],
        ort: [],
    });

    const [showResults, setShowResults] = useState(false);

    // const getSuggestions = (field, value) => {
    //     if (!value.trim()) {
    //         setSuggestions((prev) => ({
    //             ...prev,
    //             [field]: [],
    //         }));
    //         return;
    //     }

    //     const uniqueValues = [
    //         ...new Set(
    //             telephoneData
    //                 ?.map((item) => {
    //                     switch (field) {
    //                         case "hauswarte":
    //                             return item.Hauswarte;
    //                         case "strasse":
    //                             return item.Strasse;
    //                         case "hausnummer":
    //                             return String(item.Nr || "");
    //                         case "ort":
    //                             return item.Ort;
    //                         default:
    //                             return "";
    //                     }
    //                 })
    //                 .filter(Boolean)
    //         ),
    //     ];

    //     const filtered = uniqueValues
    //         .filter((item) =>
    //             item.toLowerCase().includes(value.toLowerCase())
    //         )
    //         .sort((a, b) => a.localeCompare(b, "de")) // alphabetically sort
    //         // .slice(0, 10);

    //     setSuggestions((prev) => ({
    //         ...prev,
    //         [field]: filtered,
    //     }));
    // };

    const getSuggestions = (field, value) => {
        const uniqueValues = [
            ...new Set(
                telephoneData
                    ?.map((item) => {
                        switch (field) {
                            case "hauswarte":
                                return item.Hauswarte;
                            case "strasse":
                                return item.Strasse;
                            case "hausnummer":
                                return String(item.Nr || "");
                            case "ort":
                                return item.Ort;
                            default:
                                return "";
                        }
                    })
                    .filter(Boolean)
            ),
        ].sort((a, b) => a.localeCompare(b, "de"));

        // If input is empty, show all suggestions
        if (!value.trim()) {
            setSuggestions((prev) => ({
                ...prev,
                [field]: uniqueValues,
            }));
            return;
        }

        const filtered = uniqueValues.filter((item) =>
            item.toLowerCase().includes(value.toLowerCase())
        );

        setSuggestions((prev) => ({
            ...prev,
            [field]: filtered,
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));

        getSuggestions(name, value);
    };

    const selectSuggestion = (field, value) => {
        setFilters((prev) => ({
            ...prev,
            [field]: value,
        }));

        setSuggestions((prev) => ({
            ...prev,
            [field]: [],
        }));
    };

    const hasActiveFilters =
        filters.hauswarte ||
        filters.strasse ||
        filters.hausnummer ||
        filters.ort;

    // const resetFilters = () => {
    //     setFilters({
    //         hauswarte: "",
    //         strasse: "",
    //         hausnummer: "",
    //         ort: "",
    //     });

    //     setFilteredTelephoneData(telephoneData);
    // };

    const resetFilters = () => {
        setFilters({
            hauswarte: "",
            strasse: "",
            hausnummer: "",
            ort: "",
        });

        setFilteredTelephoneData([]);
        setShowResults(false);

        setSuggestions({
            hauswarte: [],
            strasse: [],
            hausnummer: [],
            ort: [],
        });
    };

    // const handleSearch = (e) => {
    //     e.preventDefault();

    //     if (isFiltered) {
    //         resetFilters();
    //         setIsFiltered(false);
    //         return;
    //     }

    //     const filtered = telephoneData.filter((item) => {
    //         return (
    //             item.Hauswarte?.toLowerCase().includes(filters.hauswarte.toLowerCase()) &&
    //             item.Strasse?.toLowerCase().includes(filters.strasse.toLowerCase()) &&
    //             String(item.Nr || "")
    //                 .toLowerCase()
    //                 .includes(filters.hausnummer.toLowerCase()) &&
    //             item.Ort?.toLowerCase().includes(filters.ort.toLowerCase())
    //         );
    //     });

    //     setFilteredTelephoneData(filtered);
    //     setIsFiltered(true);
    // };

    const handleSearch = (e) => {
        e.preventDefault();

        if (!hasActiveFilters) {
            setShowResults(false);
            setFilteredTelephoneData([]);
            return;
        }

        const filtered = telephoneData.filter((item) => {
            return (
                item.Hauswarte?.toLowerCase().includes(filters.hauswarte.toLowerCase()) &&
                item.Strasse?.toLowerCase().includes(filters.strasse.toLowerCase()) &&
                String(item.Nr || "")
                    .toLowerCase()
                    .includes(filters.hausnummer.toLowerCase()) &&
                item.Ort?.toLowerCase().includes(filters.ort.toLowerCase())
            );
        });

        setFilteredTelephoneData(filtered);
        setShowResults(true);

        setSuggestions({
            hauswarte: [],
            strasse: [],
            hausnummer: [],
            ort: [],
        })
    };


    useEffect(() => {
        const timer = setTimeout(() => {

            if (!searchTerm.trim()) {
                setFilteredTelephoneData(telephoneData);
                return;
            }

            const filtered = telephoneData?.filter((item) => {
                const search = searchTerm.toLowerCase();

                return (
                    item?.Hauswarte?.toLowerCase().includes(search) ||
                    item?.Strasse?.toLowerCase().includes(search) ||
                    item?.Ort?.toLowerCase().includes(search)
                );
            });

            setFilteredTelephoneData(filtered);

        }, 500); // 2.5 seconds

        return () => clearTimeout(timer);

    }, [searchTerm, telephoneData]);


    useEffect(() => {
        if (!hasActiveFilters) {
            setShowResults(false);
            setFilteredTelephoneData([]);
            setIsFiltered(false);
        }
    }, [filters]);


    const showAllSuggestions = (field) => {
        const uniqueValues = [
            ...new Set(
                telephoneData
                    ?.map((item) => {
                        switch (field) {
                            case "hauswarte":
                                return item.Hauswarte;
                            case "strasse":
                                return item.Strasse;
                            case "hausnummer":
                                return String(item.Nr || "");
                            case "ort":
                                return item.Ort;
                            default:
                                return "";
                        }
                    })
                    .sort((a, b) => a.localeCompare(b, "de"))
                    .filter(Boolean)
            ),
        ];

        setSuggestions((prev) => ({
            ...prev,
            [field]: uniqueValues,
        }));
    };

    const hideSuggestions = (field) => {
        setTimeout(() => {
            setSuggestions(prev => ({
                ...prev,
                [field]: [],
            }));
        }, 100);
    };



    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-2-text-bild" && (
                            <Header_2 module={module} isLoading={isLoading} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-wohnen" activePage='wohnen' />
                        )}
                    </React.Fragment>
                ))
            )}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-3-titel-text-bild" && (
                            <Header_3 module={module} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-wohnen" activePage="wohnen" />
                        )}
                    </React.Fragment>
                ))
            )}

            {!isLoading ? (
                modules?.map((module, index) => (
                    <React.Fragment key={index}>

                        {module.__component === "modules.short-titel-titel-text-button" &&
                            <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    {/* <div className='subtitle'><img src='https://backend.bgzurlinden.ch/uploads/logo_icon_981b559742.svg' alt='#' /> zurlinden</div> */}
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                </div>
                            </section>
                        }

                        {module.__component === "modules.carousel-bild-re-text" &&
                            <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="green" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} />
                        }
                        {module.__component === "modules.notfallnummern" &&
                            // <TabsData module={module} section='notefall' />
                            <HauswartungTabData module={module} section='notefall' />
                        }
                    </React.Fragment>
                ))
            ) : (
                <>
                    <section className={`banner_sec inner_banner wohnen-banner position-relative`}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                                    <h1>{<Skeleton count={1} />}</h1>
                                    <p>{<Skeleton count={3} />}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className={`pt-pb-10 sec-orange-color`}>
                        <div className='container'>
                            <div className='title-text-button-module'>
                                {/* {shortTitle && <div className='subtitle'>{shortTitle}</div>} */}
                                <div className='row'>
                                    <div className='col-lg-5 title-col'>
                                        {/* {title && <h2 className='text-black mb-lg-4 mb-2'>{title}</h2>} */}
                                        <h2>{<Skeleton count={1} />}</h2>
                                    </div>
                                    <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                                        <p>{<Skeleton count={3} />}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}

            <section className='pt-pb-10 sec-bg-grey sec-orange-color sec-digital-directory'>
                <div className='container'>
                    {/* <div className="search-bar">
                        <form>
                            <input
                                type="text"
                                placeholder='Suche nach Strasse, Hausnummer, Ort oder Hauswart...'
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </form>
                    </div> */}

                    {/* <div class="search-box search-sort-filter">
                        <form className='w-100'>
                            <input type="text" placeholder='Suche nach Strasse, Hausnummer, Ort oder Hauswart...' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                            {searchTerm?.length > 0 && <button className='clear-search' onClick={() => setSearchTerm('')}>
                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.33128 18.2903C-0.111227 17.8478 -0.111225 17.1279 0.331282 16.6853L7.70556 9.31107L0.331281 1.9368C-0.111226 1.49429 -0.111227 0.774313 0.33128 0.331806C0.773788 -0.110702 1.49383 -0.110773 1.93634 0.331735L9.31062 7.70601L16.6848 0.331805C17.1273 -0.110702 17.8473 -0.110702 18.2898 0.331806C18.7323 0.774313 18.7324 1.49436 18.2899 1.93687L10.9157 9.31107L18.2899 16.6853C18.7324 17.1278 18.7323 17.8478 18.2898 18.2903C17.8473 18.7328 17.1273 18.7328 16.6848 18.2903L9.31062 10.9161L1.93634 18.2904C1.49384 18.7329 0.773788 18.7328 0.33128 18.2903Z" fill="#F18300" /></svg>
                            </button>}
                        </form>
                    </div> */}
                    {/* {filteredTelephoneData?.length === 0 && <div className="no-result mt-3">
                        <h5>Keine Ergebnisse gefunden</h5>
                    </div>} */}

                    <div class="title-text-button-module ">
                        <div class="subtitle">Digitales Verzeichnis</div>
                        <div class="row eql_col_content">
                            <div class="col-lg-5 title-col">
                                <h2>Hauswarte der Baugenossenschaft Zurlinden</h2>
                            </div>
                            <div class="col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500">
                                <p>Die Hauswarte der BGZ sind Ihre ersten Ansprechpersonen vor Ort. Hier finden Sie alle zuständigen Kontaktpersonen nach Siedlung.</p>
                            </div>
                        </div>
                    </div>

                    <div className='digital-directroy-table mt-4 mt-lg-5'>
                        <div className='filter_form'>
                            <form onSubmit={handleSearch}>
                                <div className='form-row row'>
                                    <div className='field-col col-6 col-lg-3'>
                                        <div className="field_inner position-relative">
                                            <div className='text-center'>
                                                <img src='images/input-icon-1.svg' alt='Hauswarte' />
                                                <h4>Hauswarte</h4>
                                            </div>
                                            <div className="position-relative filter-input-wrapper">
                                                <input type='text' name='hauswarte' value={filters.hauswarte} onChange={handleChange} onFocus={() => showAllSuggestions("hauswarte")} onBlur={() => hideSuggestions("hauswarte")} className='filter-input haus_input' placeholder='Hauswarte' disabled={isFiltered} />
                                                <img className='search-icon' onClick={handleSearch} src="images/input-icon-search.svg" alt="" style={{ position: 'absolute', right: '7px', top: '50%', transform: 'translateY(-50%)' }} />
                                            </div>
                                            {suggestions.hauswarte.length > 0 && (
                                                <ul className="suggestion-dropdown">
                                                    {suggestions.hauswarte.map((item, index) => (
                                                        <li
                                                            key={index}
                                                            onClick={() =>
                                                                selectSuggestion("hauswarte", item)
                                                            }
                                                        >
                                                            {item}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                    <div className='field-col col-6 col-lg-3'>
                                        <div className="field_inner position-relative">
                                            <div className='text-center'>
                                                <img src='images/input-icon-2.svg' alt='Strasse' />
                                                <h4>Strasse</h4>
                                            </div>
                                            <div className="position-relative filter-input-wrapper">
                                                <input type='text' name='strasse' value={filters.strasse} onChange={handleChange} onFocus={() => showAllSuggestions("strasse")} onBlur={() => hideSuggestions("strasse")} className='filter-input strase_input' placeholder='Strasse' disabled={isFiltered} />
                                                <img className='search-icon' onClick={handleSearch} src="images/input-icon-search.svg" alt="" style={{ position: 'absolute', right: '7px', top: '50%', transform: 'translateY(-50%)' }} />
                                            </div>
                                            {suggestions.strasse.length > 0 && (
                                                <ul className="suggestion-dropdown">
                                                    {suggestions.strasse.map((item, index) => (
                                                        <li
                                                            key={index}
                                                            onClick={() =>
                                                                selectSuggestion("strasse", item)
                                                            }
                                                        >
                                                            {item}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                    <div className='field-col col-6 col-lg-3'>
                                        <div className="field_inner position-relative">
                                            <div className='text-center'>
                                                <img src='images/input-icon-3.svg' alt='Hausnummer' />
                                                <h4>Hausnummer</h4>
                                            </div>
                                            <div className="position-relative filter-input-wrapper">
                                                <input type='text' name='hausnummer' value={filters.hausnummer} onChange={handleChange} onBlur={() => hideSuggestions("hausnummer")} className='filter-input hsnumer_input' placeholder='Hausnummer' disabled={isFiltered} />
                                                <img className='search-icon' onClick={handleSearch} src="images/input-icon-search.svg" alt="" style={{ position: 'absolute', right: '7px', top: '50%', transform: 'translateY(-50%)' }} />
                                            </div>
                                            {suggestions.hausnummer.length > 0 && (
                                                <ul className="suggestion-dropdown">
                                                    {suggestions.hausnummer.map((item, index) => (
                                                        <li
                                                            key={index}
                                                            onClick={() =>
                                                                selectSuggestion("hausnummer", item)
                                                            }
                                                        >
                                                            {item}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                    <div className='field-col col-6 col-lg-3'>
                                        <div className="field_inner position-relative">
                                            <div className='text-center'>
                                                <img src='images/input-icon-4.svg' alt='Ort' />
                                                <h4>Ort</h4>
                                            </div>
                                            <div className="position-relative filter-input-wrapper">
                                                <input type='text' name='ort' value={filters.ort} onChange={handleChange} onFocus={() => showAllSuggestions("ort")} onBlur={() => hideSuggestions("ort")} className='filter-input ort_input' placeholder='Ort' disabled={isFiltered} />
                                                <img className='search-icon' onClick={handleSearch} src="images/input-icon-search.svg" alt="" style={{ position: 'absolute', right: '7px', top: '50%', transform: 'translateY(-50%)' }} />
                                            </div>
                                            {suggestions.ort.length > 0 && (
                                                <ul className="suggestion-dropdown">
                                                    {suggestions.ort.map((item, index) => (
                                                        <li
                                                            key={index}
                                                            onClick={() =>
                                                                selectSuggestion("ort", item)
                                                            }
                                                        >
                                                            {item}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                    <div className='field-col col-12 text-center'>
                                        <button type='submit' className='button round_btn btn-orange-color filter-btnn d-sm-inline-flex d-none' value={isFiltered ? "Filter entfernen" : "Jetzt finden"}>Jetzt finden
                                            <span><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.7733 15.4513C20.7593 16.0532 20.2599 16.5526 19.6579 16.5667C19.056 16.5807 18.5794 16.1041 18.5934 15.5021L18.9037 2.20548L5.60703 2.51577C5.00507 2.52982 4.52846 2.05321 4.54251 1.45125C4.55657 0.849296 5.05594 0.349907 5.6579 0.33586L20.0445 0.000170705C20.6465 -0.0138708 21.1231 0.462731 21.109 1.06469L20.7733 15.4513Z" fill="inherit"></path><path d="M1.84309 20.7715C1.40751 21.2071 0.717391 21.2232 0.301672 20.8075C-0.114047 20.3918 -0.0979427 19.7017 0.337642 19.2661L19.2663 0.337392C19.7019 -0.0981931 20.3921 -0.114298 20.8078 0.301422C21.2235 0.717141 21.2074 1.40726 20.7718 1.84284L1.84309 20.7715Z" fill="inherit"></path></svg></span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        {showResults && (
                            <div className='desktop-table'>
                                <div className='table-wrapper-border'>
                                    <div className='table-responsive'>
                                        <table className='table w-100'>
                                            <thead>
                                                <tr>
                                                    <th>Hauswarte</th>
                                                    <th>Telefon</th>
                                                    <th>Strasse</th>
                                                    <th>Nr.</th>
                                                    <th>Ort</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredTelephoneData?.length > 0 ? (
                                                    filteredTelephoneData?.map((item) => (
                                                        <tr key={item.id}>
                                                            <td>{item.Hauswarte}</td>
                                                            <td className=''>
                                                                {item.Telefon && (
                                                                    <Link className='tel-link-text' to={`tel:${item.Telefon.replace(/\s/g, "")}`}>
                                                                        {item.Telefon}
                                                                    </Link>
                                                                )}
                                                                {item.Email ? (
                                                                    <Link className='mail-link-text' to={`mailto:${item.Email}`}>
                                                                        <img src='images/icon-envelope-orange.svg' alt="" />
                                                                    </Link>
                                                                ) : (
                                                                    <Link className='mail-link-text' to={`mailto:info@bgzurlinden.ch`}>
                                                                        <img src='images/icon-envelope-orange.svg' alt="" />
                                                                    </Link>
                                                                )}
                                                            </td>
                                                            <td>{item.Strasse}</td>
                                                            <td>{item.Nr}</td>
                                                            <td>{item.Ort}</td>
                                                        </tr>
                                                    ))) : (
                                                    <tr>
                                                        <td>-</td>
                                                        <td>Keine Ergebnisse gefunden</td>
                                                        <td>-</td>
                                                        <td>-</td>
                                                        <td>-</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}

                        {showResults && (<div className='mobile-table'>
                            <div className='table-mobile'>
                                {filteredTelephoneData?.length > 0 ? (
                                    filteredTelephoneData?.map((item, index) => (
                                        <ul key={index}>
                                            <li><strong>Hauswarte: </strong>{item.Hauswarte}</li>
                                            <li><strong>Telefon: </strong><Link className='tel-link-text' to={`tel:${item.Telefon.replace(/\s/g, "")}`}>{item.Telefon}</Link><Link className='mail-link-text' to={`mailto:${item.Email || 'info@bgzurlinden.ch'}`}><img src='/images/icon-envelope-orange.svg' /></Link> </li>
                                            <li><strong>Strasse: </strong>{item.Strasse}</li>
                                            <li><strong>Nr: </strong>{item.Nr}</li>
                                            <li><strong>Ort: </strong>{item.Ort}</li>
                                        </ul>
                                    ))) : (
                                    <ul>
                                        <li>Keine Ergebnisse gefunden</li>
                                    </ul>
                                )}
                            </div>
                        </div>)}
                    </div>
                </div>
            </section>
        </div>
    )
}